export const DELIVERY_RATES_TABS_HEADING = {
  INDIAN: 'Indian',
  FOREIGN: 'Foreign',
};
